import { colors, variables } from "../../../../common/styles";
const { green } = colors;
const { sideBarWidth } = variables;

const ACCORDION_HEADER_MIN_HEIGHT = 50;
const ACCORDION_HEADER_MAX_HEIGHT = 60;
const ACCORDION_DETAILS_MAX_HEIGHT = 175;

export default (theme) => ({
    accordionContainer: {
        borderBottom: "1px solid #ddd"
    },
    accordionHeader: {
        minHeight: `${ACCORDION_HEADER_MIN_HEIGHT}px !important`,
        maxHeight: ACCORDION_HEADER_MAX_HEIGHT
    },
    accordionDetails: {
        maxHeight: ACCORDION_DETAILS_MAX_HEIGHT,
        overflow: "scroll"
    },
    actionButtonContainer: {
        textAlign: "right"
    },
    actionButton: {
        margin: `0 0 0 ${theme.spacing(1)} `
    },
    buttonContainer: {
        display: "inline-block"
    },
    buttonStyle: {
        width: "40%",
        borderRadius: "25px",
        margin: "0.5rem 1rem"
    },
    buttonBorderRadius: {
        borderRadius: "25px"
    },
    columnLabel: {
        color: "#999",
        display: "inline-block",
        width: "85px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        verticalAlign: "middle"
    },
    columnIcon: {
        color: "#b4b4b6",
        verticalAlign: "middle",
        marginRight: "5px"
    },
    columnText: {
        display: "inline-block",
        color: "#2C2E2F",
        width: "auto",
        fontSize: "0.8em",
        textOverflow: "ellipsis",
        overflow: "hidden",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        width: "14em"
    },
    commonSpacing: {
        padding: "6px 12px !important"
    },
    detailContainer: {
        mx: 0.5,
        "& svg": {
            marginRight: 0.5
        }
    },
    flexGrow: {
        flexGrow: 1
    },
    fullHeight: {
        height: "100%"
    },
    fullWidth: {
        width: "100%"
    },
    textStyle: {
        marginRight: 0.5,
        fontSize: 10,
        textTransform: "capitalize"
    },
    iconLeft: {
        marginLeft: -theme.spacing(2)
    },
    marginLeft: {
        marginLeft: theme.spacing(1)
    },
    matchesPaper: {
        borderRadius: 0,
        height: "100%",
        overflow: "auto",
        width: sideBarWidth
    },
    matchesSubheader: {
        backgroundColor: theme.palette.common.white
    },
    noImagesPlaceHolder: {
        "&:hover": {
            opacity: "0.7"
        },
        background: "rgba(0, 0, 0, 0.75)",
        color: "white",
        padding: "1em",
        textAlign: "center",
        transition: "all 1s"
    },
    notesBackground: {
        backgroundColor: colors.green
    },
    overflowHidden: {
        overflow: "hidden"
    },
    spacer: {
        height: theme.spacing(3)
    },
    identifierContainer: {
        position: "absolute",
        top: "50%",
        left: "calc(50% - 16px)",
        zIndex: 2,
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        padding: 0.5
    },
    copyBtn: {
        paddingX: 2,
        paddingY: 1,
        borderRadius: "999px", // pill shape
        border: "1px solid #ccc",
        textTransform: "none",
        fontWeight: 500,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
            backgroundColor: "#f0f0f0",
            borderColor: "#bbb"
        }
    },
    swapIdentifiersBtn: {
        minWidth: "32px",
        height: "32px",
        padding: 0,
        borderRadius: "50%",
        "&:hover": {
            backgroundColor: "#e0e0e0"
        }
    },
    textCapitalize: {
        textTransform: "capitalize"
    },
    thickButton: {
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2)
    }
});
